// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BJfk","col":"styles_col__18Tkx"};